import p from "./index469.js";
import { resolveComponent as m, createElementBlock as e, createCommentVNode as n, openBlock as s, createVNode as _, createElementVNode as t, createBlock as d, toDisplayString as r } from "vue";
/* empty css         */
import B from "./index231.js";
const f = ["data-component"], u = ["src"], g = { class: "ms-smartBanner__textWrapper" }, k = {
  key: 0,
  class: "ms-smartBanner__name"
}, D = {
  key: 1,
  class: "ms-smartBanner__description"
}, h = ["href"];
function y(a, o, v, C, $, b) {
  const l = m("ms-close"), i = m("ms-stars-rating");
  return a.isVisible ? (s(), e("div", {
    key: 0,
    class: "ms-smartBanner",
    "data-component": a.$options.name
  }, [
    _(l, {
      class: "ms-smartBanner__closeBtn",
      onClick: a.close
    }, null, 8, ["onClick"]),
    t("img", {
      src: a.smartBannerData.iconUrl,
      class: "ms-smartBanner__logo",
      alt: "banner icon"
    }, null, 8, u),
    t("div", g, [
      a.smartBannerData.appTitle ? (s(), e("div", k, r(a.smartBannerData.appTitle), 1)) : n("", !0),
      a.smartBannerData.costs ? (s(), e("div", D, r(a.smartBannerData.costs), 1)) : n("", !0),
      a.smartBannerData.rating ? (s(), d(i, {
        key: 2,
        class: "ms-smartBanner__rating",
        rating: a.smartBannerData.rating,
        "max-rating": 5,
        "yellow-empty-stars": !0
      }, null, 8, ["rating"])) : n("", !0)
    ]),
    t("a", {
      href: a.smartBannerData.link,
      target: "_blank",
      rel: "nofollow noopener",
      class: "ms-smartBanner__cta",
      onClick: o[0] || (o[0] = (...c) => a.close && a.close(...c))
    }, r(a.smartBannerData.buttonText), 9, h)
  ], 8, f)) : n("", !0);
}
const E = /* @__PURE__ */ B(p, [["render", y], ["__scopeId", "data-v-41f22f7c"]]);
export {
  E as default
};
